import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestStatus } from 'ngxs-requests-plugin';
import { DownloadOptionsService } from '../services/download-options.service';

export const GetDownloadOptionsResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const downloadOptionsService = inject(DownloadOptionsService);
  if (!!downloadOptionsService.getDownloadOptionsSnapshot()?.length) {
    return true;
  }
  downloadOptionsService.getDownloadOptions();
  return downloadOptionsService.getDownloadOptionsRequestState$.pipe(
    filter(({loaded, status}) => loaded && status === RequestStatus.Success),
    take(1),
    map(res => {
      return res.data;
    })
  );
}
